import { Disclosure } from 'anf-core-react';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import SiteMapLinks from './SiteMapLinks';
import SiteMapSubCategories from './SiteMapSubCategories';
import skipSiteMapLink from './tools/skipSiteMapLink';

const SiteMapItems = ({ item, className }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const clickHandler = () => setIsExpanded(!isExpanded);
  const subCategories = item.subCategories || [];

  if (skipSiteMapLink(item)) {
    return null;
  }

  return (
    <li className={className}>
      {subCategories?.length ? (
        <Disclosure
          headingPrefix={
            item.url ? (
              <a href={item.url}>{item.name}</a>
            ) : (
              <span>{item.name}</span>
            )
          }
          id={`button-${item.categoryId}`}
          isExpanded={isExpanded}
          label=""
          onClick={clickHandler}
        >
          <SiteMapSubCategories
            className="levelCategoryWrapper"
            renderItem={(subCategory) => (
              <SiteMapItems
                key={subCategory.categoryId}
                className="levelCategory"
                item={subCategory}
              />
            )}
            subCategories={subCategories}
          />
        </Disclosure>
      ) : (
        <SiteMapLinks name={item.name} newWindow={item.newWindow} url={item.url} />
      )}
    </li>
  );
};

SiteMapItems.propTypes = {
  item: PropTypes.shape({
    categoryId: PropTypes.string.isRequired,
    url: PropTypes.string,
    name: PropTypes.string.isRequired,
    newWindow: PropTypes.bool,
    brand: PropTypes.string,
    subCategories: PropTypes.arrayOf(
      PropTypes.shape({
        categoryId: PropTypes.string.isRequired,
        url: PropTypes.string,
        name: PropTypes.string.isRequired,
        newWindow: PropTypes.bool,
      }),
    ),
  }).isRequired,
  className: PropTypes.string.isRequired,
};

export default SiteMapItems;
